<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-calendar heroicon heroicons-lg"
  >
    <rect
      class="heroicon-calendar-month heroicon-component-fill"
      width="100"
      height="79"
      y="21"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-calendar-binding heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M79 6h21v15H0V6h21v6a3 3 0 1 0 6 0V6h46v6a3 3 0 1 0 6 0V6z"
    ></path>
    <rect
      class="heroicon-calendar-date heroicon-component-accent heroicon-component-fill"
      width="14"
      height="12"
      x="69"
      y="51"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-calendar-rings heroicon-component-fill"
      fill="#FFFFFF"
      d="M21 4a3 3 0 0 1 6 0v8a3 3 0 0 1-6 0V4zm52 0a3 3 0 0 1 6 0v8a3 3 0 0 1-6 0V4z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M79 6v6a3 3 0 0 1-6 0V6v2a3 3 0 1 0 6 0V6zM27 6v6a3 3 0 0 1-6 0V6v2a3 3 0 1 0 6 0V6zM1 90h98v9H1v-9zm0-71h98v4H1v-4z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M20 4a4 4 0 0 1 8 0v2h44V4a4 4 0 0 1 8 0v2h20v94H0V6h20V4zm0 4H2v10h96V8H80v4a4 4 0 0 1-8 0V8H28v4a4 4 0 0 1-8 0V8zm78 11H2v1h96v-1zM2 22v67h96V22H2zM24 2a2 2 0 0 0-2 2v8a2 2 0 0 0 4 0V4a2 2 0 0 0-2-2zm50 2v8a2 2 0 0 0 4 0V4a2 2 0 0 0-4 0zm24 87H2v1h30v1H2v1h40v1H2v3h96v-1H68v-1h30v-3H58v-1h40v-1zM17 29h1v11h12V29h1v11h12V29h1v11h12V29h1v11h12V29h1v11h12V29h1v11h13v1H83v10h13v1H83v10h13v1H83v10h13v1H83v11h-1V74H70v11h-1V74H57v11h-1V74H44v11h-1V74H31v11h-1V74H18v11h-1V74H4v-1h13V63H4v-1h13V52H4v-1h13V41H4v-1h13V29zm65 44V63H70v10h12zm0-11V52H70v10h12zm0-11V41H70v10h12zM57 41v10h12V41H57zm0 11v10h12V52H57zm0 11v10h12V63H57zm-1 10V63H44v10h12zm0-11V52H44v10h12zm0-11V41H44v10h12zM31 41v10h12V41H31zm0 11v10h12V52H31zm0 11v10h12V63H31zm-1 10V63H18v10h12zm0-11V52H18v10h12zm0-11V41H18v10h12zm42 14h2v2h-2v-2zm2-11v2h-2v-2h2zm-2-11h2v2h-2v-2zm-11 0v2h-2v-2h2zm-2 11h2v2h-2v-2zm2 11v2h-2v-2h2zm-15 0h2v2h-2v-2zm2-11v2h-2v-2h2zm-2-11h2v2h-2v-2zm-11 0v2h-2v-2h2zm-2 11h2v2h-2v-2zm2 11v2h-2v-2h2zm-15 0h2v2h-2v-2zm2-11v2h-2v-2h2zm-2-11h2v2h-2v-2zm56-18v1H24v-1h52zm-17 7h2v2h-2v-2zm15 0v2h-2v-2h2zm11 0h2v2h-2v-2zM9 43v2H7v-2h2zm78 0v2h-2v-2h2zM7 54h2v2H7v-2zm78 0h2v2h-2v-2zM9 65v2H7v-2h2zm78 0v2h-2v-2h2zM7 76h2v2H7v-2zm15 0v2h-2v-2h2zm11 0h2v2h-2v-2zm15 0v2h-2v-2h2zm11 0h2v2h-2v-2zm15 0v2h-2v-2h2zm11 0h2v2h-2v-2z"
    ></path>
  </svg>
</template>
